import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight, Search, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface PdfSearchBarProps {
  query: string;
  resultCount: number;
  currentResultIndex: number;
  onQueryChange: (query: string) => void;
  onSubmit: (event: React.FormEvent) => void;
  onPrevResult: () => void;
  onNextResult: () => void;
  onClose: () => void;
}

const PdfSearchBar: React.FC<PdfSearchBarProps> = ({
  query,
  resultCount,
  currentResultIndex,
  onQueryChange,
  onSubmit,
  onPrevResult,
  onNextResult,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <form
      onSubmit={onSubmit}
      className="mb-2 flex items-center gap-2 rounded-md border bg-card p-2 shadow-sm"
    >
      <Input
        className="revy-cjk h-8 flex-1 text-sm leading-[1.5]"
        placeholder={t('documents.searchInDocument')}
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
      />
      <Button type="submit" variant="ghost" size="icon-sm" aria-label={t('common.search')}>
        <Search />
      </Button>
      {resultCount > 0 && (
        <>
          <span className="revy-figure min-w-[80px] text-center text-sm">
            {currentResultIndex + 1} / {resultCount}
          </span>
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            onClick={onPrevResult}
            aria-label={t('documents.previousResultShortcut')}
          >
            <ChevronLeft />
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            onClick={onNextResult}
            aria-label={t('documents.nextResultShortcut')}
          >
            <ChevronRight />
          </Button>
        </>
      )}
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        onClick={onClose}
        aria-label={t('common.close')}
      >
        <X />
      </Button>
    </form>
  );
};

export default PdfSearchBar;
